<script setup lang="ts">

</script>

<template>
    <v-chip
        variant="flat"
        color="#C0DAF8"
        size="x-small"
        class="text-blue-darken-4 mr-1 px-2 text-caption"
    >
        <v-icon
            color="#1F3565"
            class="mr-1"
            size="small"
        >
            mdi-file-document-edit-outline
        </v-icon>
        Draft
    </v-chip>
</template>

<style scoped>

</style>
